import { render } from "./Status.vue?vue&type=template&id=d35cf45c"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"

import "./Status.vue?vue&type=style&index=0&id=d35cf45c&lang=scss"
script.render = render

export default script